import React from 'react'
import { Link } from 'react-router'

const title = Object.assign({fontFamily: 'Oswald'}, {fontSize: '54px'}, {color: 'black'}, {textDecoration: 'none'})
const trans = {background: 'transparent'}

class Main extends React.Component {
  render () {
    return (
      <div>
         <nav className="navbar col-md-8 col-md-offset-2">
          <div className="container-fluid">
            <ul className="nav navbar-nav">
              <li><Link to="/">Home</Link></li>
              <li><a href="http://www.draftpicktradecalculator.com">Draft Pick Trade Calculator</a></li>
              <li><Link to="/howitworks">How It Works</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/changelog">Changelog</Link></li>
            </ul>
            <ul className="nav navbar-nav navbar-right">
              <li><a href="https://www.fantasymath.com">Fantasy Math</a></li>
            </ul>
          </div>
        </nav>
        <div className="col-md-8 col-md-offset-2" style={trans}>
          <div className="text-center">
            <strong><Link to="/"><h1 style={title}>The Fantasy Football<br/>Keeper Trade Calculator </h1></Link></strong>
            <br/>
          </div>
          {React.cloneElement(this.props.children, this.props)}
        </div>
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js